export default function buildAuthRedirectUrl(redirect, origin = window.location.origin) {
  if (typeof redirect !== 'string' || redirect.length === 0) return '/app';

  const path = redirect.startsWith('/') ? redirect : `/${redirect}`;
  return `${origin}${path}`;
}
